export class ListQueryExecutionsV2Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "queryExecutions",
            "baseName": "queryExecutions",
            "type": "Array<QueryExecutionV2>",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return ListQueryExecutionsV2Response.attributeTypeMap;
    }
    constructor() {
    }
}
